module.exports = {"510922001":"子昂街道","510922002":"平安街道","510922100":"太和镇","510922101":"大榆镇","510922102":"广兴镇","510922103":"金华镇","510922104":"沱牌镇","510922105":"太乙镇","510922106":"金家镇","510922107":"复兴镇","510922108":"天仙镇","510922109":"仁和镇","510922110":"青岗镇","510922111":"洋溪镇","510922112":"香山镇","510922113":"明星镇","510922114":"涪西镇","510922115":"陈古镇","510922116":"凤来镇","510922117":"潼射镇","510922118":"曹碑镇","510922119":"官升镇","510922200":"瞿河乡","510922201":"伏河乡","510922202":"青堤乡","510922203":"双溪乡","510922204":"文升乡","510922205":"万林乡","510922206":"太兴乡","510922207":"东岳乡","510922208":"金鹤乡","510922209":"玉太乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510922.json
// module id = 2450
// module chunks = 0